import { Badge } from "./ui/badge";

const STYLE = {
    preferred: "bg-primary/10 text-primary border-primary/30",
    speculative: "bg-accent/15 text-accent border-accent/40",
    avoid: "bg-destructive/15 text-destructive border-destructive/30",
    unknown: "bg-muted text-muted-foreground border-transparent",
};

const LABEL = {
    preferred: "Preferred Zone",
    speculative: "Speculative",
    avoid: "Avoid Zone",
    unknown: "Zone unknown",
};

const ZoneBadge = ({ zone, testid }) => {
    const key = STYLE[zone] ? zone : "unknown";
    return (
        <Badge
            data-testid={testid}
            variant="outline"
            className={`font-medium uppercase tracking-wider text-[10px] py-0.5 ${STYLE[key]}`}
        >
            {LABEL[key]}
        </Badge>
    );
};

export default ZoneBadge;
